;(function ($) {
  $.petrescue.init('body.admin-tools-data_kiosk', function () {
    var $form = $('.admin_data_kiosk_form')
    var $dateRangeContainer = $('.preset-date-ranges')

    $dateRangeContainer.on('click', 'a:not(.processing)', function (e) {
      $(this).siblings('a').addClass('processing')

      $form.find('#admin_data_kiosk_form_date_from').val($(this).data('date-from'))

      $form.find('#admin_data_kiosk_form_date_to').val($(this).data('date-to'))

      $form.trigger('submit')

      e.preventDefault()
    })
  })
})(jQuery)
